#import "../../../../CorporateChartOfAccountsFields.graphql"
query CorporateChartOfAccount($id: UUID!) {
  corporateChartOfAccount(id: $id) {
    ...CorporateChartOfAccountsFields
  }
}
